// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"EO","categoryName":"FO","categoryImage":"GO","categoryContent":"HO"};